import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aa2c15e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "image_box"
}
const _hoisted_2 = { style: {"width":"200px","height":"153px","margin-bottom":"5px"} }
const _hoisted_3 = {
  class: "custom-slick-arrow",
  style: {"left":"10px","z-index":"1"}
}
const _hoisted_4 = {
  class: "custom-slick-arrow",
  style: {"right":"10px"}
}

import { getPickImage, getOralDetectioOss, replaceImage } from '@/api/order';
import { reactive, toRefs, onMounted } from 'vue'
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PickImage',
  props: {
    oralDetectionOrderId: String,
    disabled:{
        type:Boolean,
        default:true
    }
},
  setup(__props) {

const props = __props;



onMounted(() => {
    init();
})

const data = reactive<{
    noTitleKey: string,
    imageList: any[],
    tabListNoTitle: any[],
    visible: boolean,
    carouselImageList: any[],
    checked: string,
    files: any,
    filesIndex: number
}>({
    noTitleKey: "S1",
    imageList: [],
    tabListNoTitle: [],
    visible: false,
    carouselImageList: [],
    checked: '',
    files: {},
    filesIndex: 0
})
const {
    noTitleKey,
    imageList,
    tabListNoTitle,
    visible,
    carouselImageList,
    checked,
    files
} = toRefs(data);

const tabType = (type: string) => {
    switch (type) {
        case "S1":
            return "闭口图片";
        case "S2":
            return "开口图片";
        case "S3":
            return "颌面图片";
        case "S4":
            return "矫治器图片";
        default:
            break;
    }
};
const imageTitle = (value: any) => {
    if (noTitleKey.value == "S3") {
        switch (value) {
            case 0:
                return "上颌";
            case 1:
                return "下颌";
            default:
                break;
        }
    } else {
        switch (value) {
            case 0:
                return "左侧";
            case 1:
                return "中间";
            case 2:
                return "右侧";
            default:
                break;
        }
    }
};


const init = () => {
    getPickImage(props.oralDetectionOrderId).then((res: any) => {
        console.log(res);
        tabListNoTitle.value = [];
        imageList.value = res.map((item: any) => {
            item.files = item.files.split(",");
            tabListNoTitle.value.push({
                key: item.phase,
                tab: tabType(item.phase),
            });
            return item;
        });
    });
}

const onTabChange = (value: string) => {
    noTitleKey.value = value;
};

const onReplaceImage = (it: any, key: string, index: number) => {
    files.value = it
    data.filesIndex = index
    console.log('替换图片', it, key);
    carouselImageList.value = []
    getOralDetectioOss({
        oralDetectionId: props.oralDetectionOrderId,
        type: it.phase
    }).then((res: { files: string; }) => {
        console.log(res.files.split(','));
        carouselImageList.value = res.files.split(',')
        visible.value = true;
        checked.value = key
    })

}

const handleOk = () => {
    // files.value.files[data.filesIndex] = checked.value
    console.log('关闭', files.value,files.value.files[data.filesIndex]);
    replaceImage({
        oralDetectionId:props.oralDetectionOrderId,
        originalFile:files.value.files[data.filesIndex],
        replaceFile:checked.value,
        phase:files.value.phase,
        id:files.value.id
    }).then((res: any) => {
        console.log(res);
        visible.value = false;
        init();
    })
}


return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, {
      style: {"width":"100%"},
      "tab-list": _unref(tabListNoTitle),
      "active-tab-key": _unref(noTitleKey),
      onTabChange: onTabChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imageList), (it) => {
          return (_openBlock(), _createElementBlock("div", {
            key: it.id
          }, [
            (it.phase == _unref(noTitleKey))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it.files, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("div", null, _toDisplayString(imageTitle(index)), 1),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_a_image, {
                          style: {"width":"200px","height":"153px"},
                          src: it.prefix + '/' + item + '.JPEG',
                          fit: "contain"
                        }, null, 8, ["src"])
                      ]),
                      (__props.disabled)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: ($event: any) => (onReplaceImage(it, item, index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("替换")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["tab-list", "active-tab-key"]),
    (_unref(visible))
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          visible: _unref(visible),
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
          title: "替换图片",
          onOk: handleOk,
          width: "60%"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_carousel, {
              arrows: "",
              "slides-to-show": 3,
              "slides-to-scroll": 3
            }, {
              prevArrow: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(LeftCircleOutlined))
                ])
              ]),
              nextArrow: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(RightCircleOutlined))
                ])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(carouselImageList), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(_component_a_space, { size: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _unref(checked),
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : null)),
                          name: "radioGroup"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, { direction: "vertical" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_image, {
                                  style: {"width":"200px","height":"153px"},
                                  src: _unref(files).prefix + '/' + item + '.JPEG',
                                  fit: "contain"
                                }, null, 8, ["src"]),
                                _createVNode(_component_a_radio, {
                                  value: item,
                                  name: "radioGroup"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value"])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})